import { useTranslation } from "react-i18next";
import { ThemeToggle } from "@/components/ui";
import { useThemeStore } from "@/store/themeStore";

/** Theme toggle wired to the portal theme store and `nav` labels. */
export function AppThemeToggle() {
  const { t } = useTranslation("nav");
  const isDark = useThemeStore((s) => s.resolved === "dark");
  const toggle = useThemeStore((s) => s.toggle);

  return (
    <ThemeToggle
      isDark={isDark}
      onToggle={toggle}
      labels={{
        switchToLight: t("theme.switchToLight"),
        switchToDark: t("theme.switchToDark"),
      }}
    />
  );
}
